import { MuleRouterLogo } from "./logos.tsx";
import { ProviderCard, useLiveUsage, type LiveResult } from "./parts.tsx";

/* ──────────────────────────────────────────────────────────────────────────
   MuleRouter: the credits left on the account. Its API only lets a key read
   the balance, so there is no spend over time or request list to show yet;
   the card says so rather than leaving people to look for it. The server
   reads it with MULEROUTER_API_TOKEN and caches it for two minutes.
   ────────────────────────────────────────────────────────────────────────── */

type MuleRouterUsage = LiveResult & { totalCredits: number; availableCredits: number; heldCredits: number };

const credits = (n: number | null | undefined) => (typeof n === "number" && Number.isFinite(n) ? n.toLocaleString(undefined, { maximumFractionDigits: 2 }) : "");

export function MuleRouterCard() {
  const live = useLiveUsage<MuleRouterUsage>("mulerouter", 2 * 60_000);
  return (
    <ProviderCard
      id="mulerouter"
      title="MuleRouter"
      logo={MuleRouterLogo}
      caption="Credits on the MuleRouter account."
      envVar="MULEROUTER_API_TOKEN"
      live={live}
    >
      {(data) => (
        <div className="signet-usage-stack">
          <div className="signet-usage-big">
            <span>Available credits</span>
            <strong className="tabular">{credits(data.availableCredits)}</strong>
          </div>
          <div className="signet-usage-figures">
            <div><span>Total</span><strong className="tabular">{credits(data.totalCredits)}</strong></div>
            <div><span>On hold</span><strong className="tabular">{credits(data.heldCredits)}</strong></div>
          </div>
          <p className="faint">Read usage totals and request history is coming soon</p>
        </div>
      )}
    </ProviderCard>
  );
}
